__turbopack_context__.v({
  "h1": "Title-module-scss-module__vz-srG__h1",
  "h2": "Title-module-scss-module__vz-srG__h2",
  "h3": "Title-module-scss-module__vz-srG__h3",
  "title": "Title-module-scss-module__vz-srG__title",
});
